import { render, staticRenderFns } from "./InfoCounter.vue?vue&type=template&id=3492923e&"
import script from "./InfoCounter.js?vue&type=script&lang=js&"
export * from "./InfoCounter.js?vue&type=script&lang=js&"
import style0 from "./InfoCounter.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports